export const insertPhoto = require("../assets/insert_photo.png");
export const callIcon = require("../assets/imagebutton_call.png");
export const notiIcon = require("../assets/imagebutton_noti.png");
